import Tooltip, { TooltipProps } from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import React, { FC, useState } from 'react';

interface CustomTooltipBaseProps {
  dense?: boolean;
  tooltipSpacing?: number;
}

export type CustomTooltipProps = Partial<CustomTooltipBaseProps> & TooltipProps;

const CustomTooltip: FC<CustomTooltipProps> = ({
  children,
  classes,
  dense,
  title,
  tooltipSpacing,
  placement,
  ...props
}: CustomTooltipProps) => {
  const [arrowRef, setArrowRef] = useState<HTMLSpanElement | null>(null);

  const booleanClassNameArgs = { 'fountain-tooltip-dense': dense };
  if (!title) {
    return children;
  }

  return (
    <Tooltip
      classes={{
        popper: classNames(booleanClassNameArgs, classes?.popper),
        // there are 8 places that use `tooltipSpacing` in `dent`; all are set to 2.5
        // todo: find a better way to apply this style
        tooltip: classNames(
          { ...booleanClassNameArgs, 'fountain-tooltip-more-margin': tooltipSpacing === 2.5 },
          classes?.tooltip,
        ),
      }}
      placement={placement}
      PopperProps={{
        popperOptions: {
          modifiers: {
            arrow: {
              element: arrowRef,
              enabled: Boolean(arrowRef),
            },
          },
        },
      }}
      title={
        <>
          <Typography className={classNames('fountain-tooltip-text', booleanClassNameArgs)} variant="overline">
            {title}
          </Typography>
          <span ref={setArrowRef} className={classNames('fountain-tooltip-arrow', booleanClassNameArgs)} />
        </>
      }
      {...props}
    >
      <span>{children}</span>
    </Tooltip>
  );
};

export default CustomTooltip;
